import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import { useRouter } from 'next/router';
import css from './index.module.scss';

const TheComp: React.FC<{
    needTitle?: boolean;
}> = ({ needTitle = true }) => {
    const { t } = useLang('dp3.teaser.OnePicture');
    const { locale } = useRouter();

    const items = [
        {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1764762277799-f4qqf9-compressed-1.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1764762542594-2hu9hq-compressed-1.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1764762436112-16r4q4-compressed-2.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1764762577031-beg23r-compressed-3.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1764762447183-1vn5g2-compressed-3.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1764762635201-n4vyyu-compressed-7.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1764762457979-rdqjmp-compressed-4.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1764762622477-gxkups-compressed-6.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1764762473396-9i5t0z-compressed-5.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1764762565261-b8sbo8-compressed-2.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1764762485154-qb9yai-compressed-6.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1764762606885-ee295j-compressed-5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1764762500015-f1zcdr-compressed-7.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1764762593255-ib2cio-compressed-4.jpg',
        },
        {
            title: t('item8_title'),
            list: [
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1745476130071/2.png', text: t('list_1') },
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1745476129935/1.png', text: t('list_2') },
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1745476130278/3.png', text: t('list_3') },
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1745476130474/4.png', text: t('list_4') },
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1745476130866/6.png', text: t('list_5') },
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1745476130668/7.png', text: t('list_6') },
                { icon: 'https://websiteoss.ecoflow.com/upload/image/1764815755275/ecology.png', text: t('list_7') },
            ],
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1764762522260-669k0e-compressed-8.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1764762649307-uwqtj0-compressed-8.jpg',
        },
    ];

    return (
        <div
            id="dp3-teaser-C"
            className={`${css.thecomp} dp3-teaser-C GtmModuleData-section`}
            style={{ backgroundColor: needTitle ? undefined : '#fff' }}
            data-section-id={'dp3-TextA'}
            data-section-title={'dp3-TextA'}
        >
            <h2 className="title">{t('title')}</h2>
            <ul className="yyds" style={{ marginTop: needTitle ? undefined : 0 }}>
                {items.map((item, k: number) => (
                    <li className={`item item${k + 1}`} key={k}>
                        <div className="item-img">
                            <EcoImg pc={item?.pc} pad={item?.pc} h5={item?.h5} />
                        </div>
                        <div className="item-info">
                            <p className="item-title">{t(`item${k + 1}_title`)}</p>
                            <p className="item-desc">{t(`item${k + 1}_desc`)}</p>
                        </div>
                        {item.list && (
                            <div className="list">
                                {item.list.map((j, idx2) => (
                                    <div className="list-item" key={`${k}-${idx2}`}>
                                        <img className="list-icon" src={j.icon} alt="" />
                                        <div className="list-text">{j.text}</div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default TheComp;
